import { GoogleGenerativeAI } from '@google/generative-ai';

/**
 * Lazy load Gemini SDK
 * @returns {Promise<GoogleGenerativeAI>}
 */
const loadGeminiSDK = async () => {
  const { GoogleGenerativeAI } = await import('@google/generative-ai');
  return GoogleGenerativeAI;
};

/**
 * Initializes the Gemini client with the API key from environment variables.
 * @returns {Promise<GoogleGenerativeAI>} Configured Gemini client instance.
 */
const getGeminiClient = async () => {
  const GoogleGenerativeAI = await loadGeminiSDK();
  return new GoogleGenerativeAI(import.meta.env.VITE_GEMINI_API_KEY);
};

export default getGeminiClient;

/**
 * Handles common Gemini API errors with user-friendly messages.
 * Simple classification: Internal errors (401, 402, 403, 429, 500-504) vs General errors
 * 
 * @param {Error} error - The error object from the API.
 * @returns {Object} Error information with message, isInternal flag, and status code.
 */
export function handleGeminiError(error) {
  if (error?.status === 401 || error?.message?.toLowerCase()?.includes("api key")) {
    return { isInternal: true, message: error?.message }
  }

  if(error?.status === 403 || error?.message?.toLowerCase()?.includes("forbidden")){
    return { isInternal: true, message: error?.message }
  }

  if(error?.status === 404 || error?.message?.toLowerCase()?.includes("not found")){
    return { isInternal: true, message: error?.message }
  }

  if(error?.status === 429 || error?.message?.toLowerCase()?.includes("rate limit exceeded")){
    return { isInternal: true, message: error?.message }
  }

  if(error?.status >= 500){
    return { isInternal: true, message: error?.message }
  }

  return {
    isInternal: false,
    message: error?.message
  }
}
function getSafetySettings(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: getSafetySettings is not implemented yet.', args);
  return null;
}

export { getSafetySettings };